(() => {
  const storageKey = 'rysnShopAnimationTarget';
  let observer;

  const normalizePath = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return `${url.pathname.replace(/\/$/, '') || '/'}${url.search}`;
    } catch (_) {
      return '';
    }
  };

  const getStoredTarget = () => {
    try {
      return sessionStorage.getItem(storageKey) || '';
    } catch (_) {
      return '';
    }
  };

  const clearStoredTarget = () => {
    try {
      sessionStorage.removeItem(storageKey);
    } catch (_) {}
  };

  // Store the exact SHOP destination. Capture phase ensures this runs before
  // Shopify's page-transition navigation intercepts the click.
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a');
      if (!link) return;

      const menuTitle = (link.dataset.menuTitle || '').trim().toLowerCase();
      const visibleTitle = (link.querySelector('.menu-list__link-title')?.textContent || link.textContent || '')
        .trim()
        .toLowerCase();

      if (menuTitle !== 'shop' && visibleTitle !== 'shop') return;

      const target = normalizePath(link.href);
      if (!target) return;

      try {
        sessionStorage.setItem(storageKey, target);
      } catch (_) {}
    },
    true
  );

  const applyShopAnimation = () => {
    const target = getStoredTarget();
    if (!target || normalizePath(window.location.href) !== target) return false;

    const main = document.getElementById('MainContent');
    const productItems = main?.querySelectorAll('.product-grid__item');
    if (!main || !productItems?.length) return false;

    // Guard against product templates and replay cleanly if Shopify morphs content.
    const template = String(main.dataset.template || '').toLowerCase();
    if (template.startsWith('product')) {
      clearStoredTarget();
      return false;
    }

    main.classList.remove('rysn-shop-entry');
    void main.offsetWidth;
    main.classList.add('rysn-shop-entry');
    clearStoredTarget();

    window.setTimeout(() => main.classList.remove('rysn-shop-entry'), 1900);
    return true;
  };

  const watchForShopContent = () => {
    if (applyShopAnimation()) return;
    if (observer) observer.disconnect();

    observer = new MutationObserver(() => {
      if (applyShopAnimation()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // Avoid leaving a permanent observer when no SHOP navigation follows.
    window.setTimeout(() => observer?.disconnect(), 10000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForShopContent, { once: true });
  } else {
    watchForShopContent();
  }

  window.addEventListener('pageshow', watchForShopContent);
  window.addEventListener('popstate', watchForShopContent);

  // Shopify themes may announce in-page renders with different events.
  ['shopify:section:load', 'shopify:section:reorder', 'page:loaded', 'theme:page:loaded'].forEach((name) => {
    document.addEventListener(name, watchForShopContent);
  });
})();
